import React, { ReactNode } from 'react'
import clsx from 'clsx'

export interface IconProps {
  className?: string
  children?: ReactNode
  id?: string
  name?: string
  'date-testid'?: string
  style?: Record<string, unknown>
  variants?: 'xxs' | 'xs' | 'sm' | 'm' | 'md' | 'lg' | 'star'
  onClick?(e: React.SyntheticEvent): void
  onMouseOver?(): void
  onMouseLeave?(): void
}

function Icon(props: IconProps): JSX.Element {
  const {
    className,
    variants = 'md',
    children,
    style,
    onClick,
    ...others
  } = props

  return (
    <div
      className={clsx(
        'icon',
        {
          [`icon--${variants}`]: Boolean(variants),
        },
        className,
      )}
      onClick={onClick}
      style={style}
      {...others}
    >
      {children}
    </div>
  )
}

export default Icon
